import { useEffect, useState } from 'react'
import { Box, Typography, useMediaQuery } from '@mui/material'
import { useHistory } from 'react-router-dom'
import { Capacitor } from '@capacitor/core'
import CookiesStorageService from '../../../services/CookiesStorageService'
import { ReactComponent as AdminIcon } from '../../../images/admin-modules.svg'
import { ReactComponent as CoreIcon } from '../../../images/core-modules.svg'
import { ReactComponent as RecIcon } from '../../../images/recruitment-modules.svg'
import { ReactComponent as EdsIcon } from '../../../images/eds-modules.svg'
import { ReactComponent as SelfIcon } from '../../../images/self-service.svg'
import { ReactComponent as OtmsIcon } from '../../../images/core-module-icon.svg'
import AppRoutes from '../../../services/AppRoutes'

const Index = () => {
  const history = useHistory()
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))

  const [userModules, setUserModules] = useState(null)

  useEffect(() => {
    setUserModules(CookiesStorageService.getUserModules())
  }, [])

  const changeModuleIconBasedOnCode = (moduleCode) => {
    switch (moduleCode) {
      case 'admin':
        return <AdminIcon />
      case 'recruitment':
        return <RecIcon />
      case 'eds':
        return <EdsIcon />
      case 'self':
        return <SelfIcon />
      case 'otms':
        return <OtmsIcon />
      default:
        return <CoreIcon />
    }
  }

  const redirectToSelectedModuleHandler = (moduleCode) => {
    if (moduleCode === 'eds') {
      window.location.href = process.env.REACT_APP_EDS_FRONTEND_URL
    } else if (moduleCode === 'recruitment') {
      window.location.href = process.env.REACT_APP_RECRUITMENT_FRONTEND_URL
    } else if (moduleCode === 'self') {
      window.location.href = `${process.env.REACT_APP_SELF_FRONTEND_URL}`
    } else if (moduleCode === 'core') {
      if (isMobile) {
        window.location.href = `${process.env.REACT_APP_CORE_FRONTEND_URL}/`
      } else {
        window.open(`${process.env.REACT_APP_CORE_FRONTEND_URL}/`, '_blank')
      }
    } else if (moduleCode === 'admin') {
      history.push(AppRoutes.home)
    }
  }

  const visibleModules = Capacitor.isNativePlatform()
    ? userModules?.filter((singleModule) => singleModule.code !== 'core')
    : userModules

  return (
    <Box sx={styles.root}>
      {(visibleModules)?.map((singleModule) => (
        <Box key={singleModule.code} sx={styles.singleModuleBtn}
             onClick={() => redirectToSelectedModuleHandler(singleModule.code)}>
          <Box sx={styles.moduleIcon}>
            {changeModuleIconBasedOnCode(singleModule.code)}
          </Box>
          <Typography>{singleModule.name}</Typography>
        </Box>
      ))}
    </Box>
  )
}

const styles = {
  root: {
    border: '1px solid #E2E8EE',
    borderRadius: '12px',
    overflow: 'hidden',
    width: '100%',
    marginLeft: { xs: '0px', sm: 'unset' },
  },

  singleModuleBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    padding: { xs: '17px', sm: '20px 17px' },
    cursor: 'pointer',
    backgroundColor: '#F5F5F5',
    borderBottom: '1px solid #E2E8EE',
    transition: 'all 0.3s ease',
    '& p': {
      width: '100%',
      textAlign: 'center',
      fontSize: { xs: '12px', sm: '16px' },
      color: '#92929D',
    },
    '&:hover': {
      borderColor: '#29cc8b',
      color: '#29cc8b',
      '& p': {
        color: '#29cc8b',
      },
      '& svg': {
        fill: '#29cc8b',
      },
      '& path': {
        fill: '#29cc8b',
      },
      '& g': {
        fill: '#29cc8b',
      },
    },
  },
  moduleIcon: {
    '& svg': {
      width: { xs: '20px', sm: '25px' },
      height: { xs: '20px', sm: '25px' },
      fill: '#828282',
      '& g': {
        fill: '#828282',
      },
    },
  },
}
export default Index
